import * as React from 'react'
import { Colors } from '@lmc/common/types'

export type ContainerProps = {
  backgroundColor?: Colors
  backgroundImage?: string
  children?: React.ReactElement
  style?: React.CSSProperties
}

export default function Container({
  backgroundColor,
  backgroundImage,
  children,
  style,
}: ContainerProps): React.ReactElement {
  const containerStyle = {
    backgroundColor,
    backgroundImage: backgroundImage && `url(${backgroundImage})`,
    ...styles.container,
    ...style,
  }

  return <div style={containerStyle}>{children}</div>
}

const styles = {
  container: {
    borderRadius: 25,
  },
}
